module.exports = __webpack_public_path__ + "img/10_1.99c63487.png";